import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useWorkspaceContext } from "@core/context";
import { downloadSingleFile } from "@modules/docs/documents/services";

export function useGetDocFile(fileId: string) {
  const { workspaceId } = useWorkspaceContext();
  const { projectId } = useParams<{ projectId: string }>();

  return useQuery({
    queryKey: ["doc-file", fileId],
    queryFn: () => downloadSingleFile(workspaceId!, projectId!, fileId),
    enabled: !!workspaceId && !!projectId && !!fileId,
  });
}
